module.exports = __webpack_public_path__ + "static/media/0.3cb61cf2.jpg";